module.exports = __webpack_public_path__ + "img/product6.91a7e926.jpg";